// Multi-word pill highlights (sm-hl-words): mark the first and last word of every rendered line
// so the pill gets rounded ends wherever the heading wraps. Re-runs on resize and font load.
const mark = () => {
  const groups = new Map();
  document.querySelectorAll('.sm-hl--start, .sm-hl--mid, .sm-hl--end').forEach((w) => {
    w.classList.remove('is-ls', 'is-le');
    const g = w.parentElement;
    if (!groups.has(g)) groups.set(g, []);
    groups.get(g).push(w);
  });
  groups.forEach((words) => {
    let run = [];
    const flush = () => { if (run.length) { run[0].classList.add('is-ls'); run[run.length - 1].classList.add('is-le'); } run = []; };
    words.forEach((w, i) => {
      if (w.classList.contains('sm-hl--start')) flush();
      const prev = run[run.length - 1];
      if (prev && Math.abs(prev.offsetTop - w.offsetTop) > 4) flush();
      run.push(w);
      if (w.classList.contains('sm-hl--end') || i === words.length - 1) flush();
    });
  });
};
let t;
const later = () => { clearTimeout(t); t = setTimeout(mark, 60); };
mark();
addEventListener('resize', later);
addEventListener('load', later);
// re-check whenever a heading with a multi-word pill changes size (late fonts, lazy sections, container width)
if ('ResizeObserver' in window) {
  const ro = new ResizeObserver(later);
  new Set([...document.querySelectorAll('.sm-hl--start')].map((w) => w.parentElement)).forEach((el) => ro.observe(el));
}
document.fonts?.ready.then(mark);
document.addEventListener('shopify:section:load', later);
